import apiService from '@/services/apiService';

const actions = {
  getTutorial({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/tutorial`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postTutorial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/tutorial', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
